/**
 * Backend (Engine.js, recompute.js, datasets.js) liefert analysis-job `detail` überwiegend auf Englisch.
 * preview.js nutzt teils schon deutsche Texte.
 *
 * Diese Datei hält EN↔DE für dieselben Muster — bei neuen Backend-Strings hier ergänzen.
 */

/** @param {string} raw */
export function translateBackendJobDetailToGerman(raw) {
  const s = String(raw || "").trim();
  if (!s) return "";

  let t = s;

  // preview.js: "N Wallet(s), Steuerjahr" (schon DE, einheitlich machen)
  t = t.replace(/(\d+)\s+Wallet\(s\),\s*Steuerjahr\s+(\d+)/gi, "$1 Wallets, Steuerjahr $2");

  // --- FIFO (recompute.js: emitLiveFifoProgress + Abschluss) ---
  t = t.replace(
    /(\d+)\s*\/\s*(\d+)\s+FIFO outflows processed\s*[·•\-–]\s*(\d+)\s+matches\s*[·•\-–]\s*(\d+)\s+NFT matches/gi,
    "$1 / $2 FIFO-Abflüsse verarbeitet · $3 Treffer · $4 NFT-Treffer"
  );
  t = t.replace(
    /(\d+)\s*\/\s*(\d+)\s+FIFO outflows processed/gi,
    "$1 / $2 FIFO-Abflüsse verarbeitet"
  );

  // --- Quellen / Wallets (Engine.js fetching) ---
  t = t.replace(/(\d+)\s*\/\s*(\d+)\s+sources loaded/gi, "$1 / $2 Quellen geladen");
  t = t.replace(/(\d+)\s+wallet\(s\),\s*tax year\s+(\d+)/gi, "$1 Wallets, Steuerjahr $2");
  t = t.replace(/(\d+)\s+wallet\(s\)(?!,)/gi, "$1 Wallets");

  t = t.replace(/TXOut sync skipped/gi, "TXOut-Sync übersprungen");
  t = t.replace(/TXOut sync completed/gi, "TXOut-Sync abgeschlossen");

  // --- Klassifizierung (Engine.js + classification sub-steps) ---
  t = t.replace(/Classification started/gi, "Klassifizierung gestartet");
  t = t.replace(/(\d+)\s*\/\s*(\d+)\s+steps\s*[·•\-–]\s*/gi, "$1 / $2 Schritte · ");
  t = t.replace(/(\d+)\s*\/\s*3\s+steps\s*[·•\-–]\s*/gi, "$1 / 3 Schritte · ");
  t = t.replace(/(\d+)\s+classified outflows/gi, "$1 klassifizierte Abflüsse");

  t = t.replace(/Normalizing transfers/gi, "Transfers normalisieren");
  t = t.replace(/Classifying VIP-180 tokens/gi, "VIP-180-Token klassifizieren");
  t = t.replace(/Classifying VIP-180 & VET\/VTHO/gi, "VIP-180 & VET/VTHO klassifizieren");
  t = t.replace(/Internal transfers & Stargate/gi, "Interne Transfers & Stargate");
  t = t.replace(/Loading NFT data & matching sales/gi, "NFT-Daten laden & Verkäufe zuordnen");
  t = t.replace(/Loading NFT data/gi, "NFT-Daten laden");
  t = t.replace(/Matching swaps/gi, "Swaps zuordnen");
  t = t.replace(/Liquidity events/gi, "Liquiditäts-Events");
  t = t.replace(/NFBC receipt scan/gi, "NFBC-Receipt-Scan");
  t = t.replace(/SolarWise receipt scan/gi, "SolarWise-Receipt-Scan");
  t = t.replace(/Matching NFT mint payments/gi, "NFT-Mint-Zahlungen zuordnen");
  t = t.replace(/Receipt-based DApp rewards/gi, "Receipt-basierte DApp-Rewards");
  t = t.replace(/NFT sales & receipt verification/gi, "NFT-Verkäufe & Receipt-Prüfung");
  t = t.replace(/Receipt & liquidity scans/gi, "Receipt- & Liquiditäts-Scans");
  t = t.replace(/Matching NFT mints/gi, "NFT-Mints zuordnen");
  t = t.replace(/DApp & reward classification/gi, "DApp- & Reward-Klassifizierung");
  t = t.replace(/Building transfer lists/gi, "Transferlisten aufbauen");
  t = t.replace(/\bDone\b/gi, "Fertig");

  // Klassifizierung — Zwischen-Details (Schritt bleibt N / 12 • …)
  t = t.replace(/Matching NFT sales \(1st pass\)/gi, "NFT-Verkäufe zuordnen (1. Durchlauf)");
  t = t.replace(/Matching NFT sales \(2nd pass\)/gi, "NFT-Verkäufe zuordnen (2. Durchlauf)");
  t = t.replace(/Golden Empire receipts/gi, "Golden-Empire-Receipts");
  t = t.replace(/Governance rewards/gi, "Governance-Rewards");
  t = t.replace(/VeBetterDAO Governor receipts/gi, "VeBetterDAO-Governor-Receipts");
  t = t.replace(/Vexchange farm receipts/gi, "Vexchange-Farm-Receipts");
  t = t.replace(/VeRocket \/ vVET receipts/gi, "VeRocket- / vVET-Receipts");
  t = t.replace(/WoV staking reward receipts/gi, "WoV-Staking-Reward-Receipts");
  t = t.replace(/WoV sale receipts \((\d+)\/(\d+)\)/gi, "WoV-Verkaufs-Receipts ($1/$2)");
  t = t.replace(/X2Earn reward receipts/gi, "X2Earn-Reward-Receipts");
  t = t.replace(/Sagaz reward receipts/gi, "Sagaz-Reward-Receipts");
  t = t.replace(/VFox Alliance reward receipts/gi, "VFox-Alliance-Reward-Receipts");
  t = t.replace(/VeSea staking reward receipts/gi, "VeSea-Staking-Reward-Receipts");
  t = t.replace(/UNION NFT holder rewards/gi, "UNION-NFT-Holder-Rewards");
  t = t.replace(/Safe Haven SHA reward receipts/gi, "Safe-Haven-SHA-Reward-Receipts");
  t = t.replace(/MVA staking reward receipts/gi, "MVA-Staking-Reward-Receipts");
  t = t.replace(/VeStation activity/gi, "VeStation-Aktivität");
  t = t.replace(/VIMworld VEED activity/gi, "VIMworld-VEED-Aktivität");
  t = t.replace(/JuicyFinance receipts/gi, "JuicyFinance-Receipts");
  t = t.replace(/Pause Your Carbon \(CY\)/gi, "Pause Your Carbon (CY)");
  t = t.replace(/BetterSwap Pool2Earn rewards/gi, "BetterSwap-Pool2Earn-Rewards");
  t = t.replace(/Golden Empire fallback/gi, "Golden-Empire-Fallback");
  t = t.replace(/NFT marketplace lifecycle/gi, "NFT-Marktplatz-Lifecycle");
  t = t.replace(/Residual NFT receipts \((\d+)\/(\d+)\)/gi, "Restliche NFT-Receipts ($1/$2)");

  // --- Preise (Engine.js pricing) ---
  t = t.replace(
    /Loading price and FX data for\s+(.+)/gi,
    "Preis- und FX-Daten werden geladen für $1"
  );
  t = t.replace(/Price and FX data loaded/gi, "Preis- und FX-Daten geladen");

  // --- FIFO-Vorbereitung / Finalisierung (Engine.js) ---
  t = t.replace(
    /(\d+)\s+FIFO-relevant outflows detected/gi,
    "$1 FIFO-relevante Abflüsse erkannt"
  );
  t = t.replace(
    /Preparing totals, tables, and snapshot/gi,
    "Summen, Tabellen und Snapshot werden vorbereitet"
  );

  // Falls Message-Texte je in `detail` landen (defensiv)
  t = t.replace(/\bRunning FIFO\b/gi, "FIFO wird ausgeführt");
  t = t.replace(/\bFIFO completed\b/gi, "FIFO abgeschlossen");
  t = t.replace(/\bPreparing FIFO\b/gi, "FIFO wird vorbereitet");
  t = t.replace(/\bTransfers loaded\b/gi, "Transfers geladen");

  t = t.replace(/\s{2,}/g, " ").trim();
  return t;
}

/** Für EN-UI: deutsche/preview-Details → lesbares Englisch (Gegenrichtung zu oben). */
/** @param {string} raw */
export function translateBackendJobDetailToEnglish(raw) {
  const s = String(raw || "").trim();
  if (!s) return "";

  let t = s;

  // preview.js: "N Wallet(s), Steuerjahr Y"
  t = t.replace(/(\d+)\s+Wallet\(s\),\s*Steuerjahr\s+(\d+)/gi, "$1 wallet(s), tax year $2");
  t = t.replace(/(\d+)\s+Wallets?,\s*Steuerjahr\s+(\d+)/gi, "$1 wallet(s), tax year $2");

  t = t.replace(
    /(\d+)\s*\/\s*(\d+)\s+FIFO-Abflüsse verarbeitet\s*·\s*(\d+)\s+Treffer\s*·\s*(\d+)\s+NFT-Treffer/gi,
    "$1 / $2 FIFO outflows processed • $3 matches • $4 NFT matches"
  );
  t = t.replace(
    /(\d+)\s*\/\s*(\d+)\s+FIFO-Abflüsse verarbeitet/gi,
    "$1 / $2 FIFO outflows processed"
  );

  t = t.replace(/(\d+)\s*\/\s*(\d+)\s+Quellen geladen/gi, "$1 / $2 sources loaded");
  t = t.replace(/(\d+)\s+Wallets?,\s*Steuerjahr\s+(\d+)/gi, "$1 wallet(s), tax year $2");
  // DE-Muster "… Quellen geladen • 3 Wallets" → englisches wallet(s)
  t = t.replace(/\s*[·•]\s*(\d+)\s+Wallets\b(?!\s*,)/gi, " • $1 wallet(s)");
  t = t.replace(/^(\d+)\s+Wallets\b(?=\s*$)/gm, "$1 wallet(s)");

  t = t.replace(/TXOut-Sync übersprungen/gi, "TXOut sync skipped");
  t = t.replace(/TXOut-Sync abgeschlossen/gi, "TXOut sync completed");

  t = t.replace(/Klassifizierung gestartet/gi, "Classification started");
  t = t.replace(/(\d+)\s*\/\s*(\d+)\s+Schritte\s*·\s*/gi, "$1 / $2 steps • ");
  t = t.replace(/(\d+)\s*\/\s*3\s+Schritte\s*·\s*/gi, "$1 / 3 steps • ");
  t = t.replace(/(\d+)\s+klassifizierte Abflüsse/gi, "$1 classified outflows");

  t = t.replace(/Transfers normalisieren/gi, "Normalizing transfers");
  t = t.replace(/VIP-180-Token klassifizieren/gi, "Classifying VIP-180 tokens");
  t = t.replace(/VIP-180 & VET\/VTHO klassifizieren/gi, "Classifying VIP-180 & VET/VTHO");
  t = t.replace(/Interne Transfers & Stargate/gi, "Internal transfers & Stargate");
  t = t.replace(/NFT-Daten laden & Verkäufe zuordnen/gi, "Loading NFT data & matching sales");
  t = t.replace(/NFT-Daten laden/gi, "Loading NFT data");
  t = t.replace(/Swaps zuordnen/gi, "Matching swaps");
  t = t.replace(/Liquiditäts-Events/gi, "Liquidity events");
  t = t.replace(/NFBC-Receipt-Scan/gi, "NFBC receipt scan");
  t = t.replace(/SolarWise-Receipt-Scan/gi, "SolarWise receipt scan");
  t = t.replace(/NFT-Mint-Zahlungen zuordnen/gi, "Matching NFT mint payments");
  t = t.replace(/Receipt-basierte DApp-Rewards/gi, "Receipt-based DApp rewards");
  t = t.replace(/NFT-Verkäufe & Receipt-Prüfung/gi, "NFT sales & receipt verification");
  t = t.replace(/Receipt- & Liquiditäts-Scans/gi, "Receipt & liquidity scans");
  t = t.replace(/NFT-Mints zuordnen/gi, "Matching NFT mints");
  t = t.replace(/DApp- & Reward-Klassifizierung/gi, "DApp & reward classification");
  t = t.replace(/Transferlisten aufbauen/gi, "Building transfer lists");
  t = t.replace(/\bFertig\b/gi, "Done");

  t = t.replace(/NFT-Verkäufe zuordnen \(1\. Durchlauf\)/gi, "Matching NFT sales (1st pass)");
  t = t.replace(/NFT-Verkäufe zuordnen \(2\. Durchlauf\)/gi, "Matching NFT sales (2nd pass)");
  t = t.replace(/Golden-Empire-Receipts/gi, "Golden Empire receipts");
  t = t.replace(/Governance-Rewards/gi, "Governance rewards");
  t = t.replace(/VeBetterDAO-Governor-Receipts/gi, "VeBetterDAO Governor receipts");
  t = t.replace(/Vexchange-Farm-Receipts/gi, "Vexchange farm receipts");
  t = t.replace(/VeRocket- \/ vVET-Receipts/gi, "VeRocket / vVET receipts");
  t = t.replace(/WoV-Staking-Reward-Receipts/gi, "WoV staking reward receipts");
  t = t.replace(/WoV-Verkaufs-Receipts \((\d+)\/(\d+)\)/gi, "WoV sale receipts ($1/$2)");
  t = t.replace(/X2Earn-Reward-Receipts/gi, "X2Earn reward receipts");
  t = t.replace(/Sagaz-Reward-Receipts/gi, "Sagaz reward receipts");
  t = t.replace(/VFox-Alliance-Reward-Receipts/gi, "VFox Alliance reward receipts");
  t = t.replace(/VeSea-Staking-Reward-Receipts/gi, "VeSea staking reward receipts");
  t = t.replace(/UNION-NFT-Holder-Rewards/gi, "UNION NFT holder rewards");
  t = t.replace(/Safe-Haven-SHA-Reward-Receipts/gi, "Safe Haven SHA reward receipts");
  t = t.replace(/MVA-Staking-Reward-Receipts/gi, "MVA staking reward receipts");
  t = t.replace(/VeStation-Aktivität/gi, "VeStation activity");
  t = t.replace(/VIMworld-VEED-Aktivität/gi, "VIMworld VEED activity");
  t = t.replace(/JuicyFinance-Receipts/gi, "JuicyFinance receipts");
  t = t.replace(/BetterSwap-Pool2Earn-Rewards/gi, "BetterSwap Pool2Earn rewards");
  t = t.replace(/Golden-Empire-Fallback/gi, "Golden Empire fallback");
  t = t.replace(/NFT-Marktplatz-Lifecycle/gi, "NFT marketplace lifecycle");
  t = t.replace(/Restliche NFT-Receipts \((\d+)\/(\d+)\)/gi, "Residual NFT receipts ($1/$2)");

  t = t.replace(
    /Preis- und FX-Daten werden geladen für\s+(.+)/gi,
    "Loading price and FX data for $1"
  );
  t = t.replace(/Preis- und FX-Daten geladen/gi, "Price and FX data loaded");

  t = t.replace(
    /(\d+)\s+FIFO-relevante Abflüsse erkannt/gi,
    "$1 FIFO-relevant outflows detected"
  );
  t = t.replace(
    /Summen, Tabellen und Snapshot werden vorbereitet/gi,
    "Preparing totals, tables, and snapshot"
  );

  t = t.replace(/\bFIFO wird ausgeführt\b/gi, "Running FIFO");
  t = t.replace(/\bFIFO abgeschlossen\b/gi, "FIFO completed");
  t = t.replace(/\bFIFO wird vorbereitet\b/gi, "Preparing FIFO");
  t = t.replace(/\bTransfers geladen\b/gi, "Transfers loaded");

  // Legacy-Einzelersetzer (ältere deutsche Formulierungen aus dem Overlay)
  t = t
    .replace(/Quellen geladen/gi, "sources loaded")
    .replace(/Transfers geladen/gi, "Transfers loaded")
    .replace(/Transfers werden geladen/gi, "Fetching transfers")
    .replace(/uebersprungen|übersprungen/gi, "skipped")
    .replace(/abgeschlossen/gi, "completed")
    .replace(/Analyse wird vorbereitet/gi, "Preparing analysis")
    .replace(/Analyse wird finalisiert/gi, "Finalizing analysis")
    .replace(/Analyse laeuft|Analyse läuft/gi, "Analysis in progress")
    .replace(/Transaktionen werden klassifiziert/gi, "Classifying transactions")
    .replace(/Preisindex wird aufgebaut/gi, "Building price index")
    .replace(/FIFO wird ausgefuehrt/gi, "Running FIFO");

  t = t.replace(/\s{2,}/g, " ").trim();

  if (/(quellen|wird|steuerjahr|transaktionen|berechnung|geladen|laeuft|läuft|analyse|schritte|treffer|abflüsse)/i.test(t)) {
    return "";
  }

  return t;
}
